import React from 'react'
import { connect } from 'react-redux'
import MappingFieldRow from './utilities/MappingFieldRow'
import AddNewForm from './utilities/AddNewForm'
import { editEndpointList, deleteEndpointList } from '../actions/endpoints'
import { fetchEndpointIfNeeded as ftch } from '../actions/fetch'
import { showMessage, closeMessage } from '../actions/messageBox'
import { deleteAllFields } from '../actions/mapping'
import { CSSTransition } from "react-transition-group"
import _ from 'lodash'

class MappingFieldTable extends React.Component {
    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleDeleteAllFields = this.handleDeleteAllFields.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.isInvalid = this.isInvalid.bind(this)
        this.buildRows = this.buildRows.bind(this)
        this.rowCounter = 0
        this.seqNo = []

        this.rowRefs = []

        let eid = this.props.mappingFields && this.props.mappingFields.find(mapField => (mapField.datatype === "e-id"))
        let pid = this.props.mappingFields && this.props.mappingFields.find(mapField => (mapField.datatype === "p-id"))
        let sid = this.props.mappingFields && this.props.mappingFields.find(mapField => (mapField.datatype === "s-id"))

        this.state = {
            mappingFields: this.props.mappingFields,
            isSubmitting: false,
            deletedFields: [],
            unsavedFields: [],
            errors: [],
            expanded: [],
            hasExternalId: eid !== undefined,
            hasPId: pid !== undefined,
            hasSId: sid !== undefined,
            isApplying: false
        }
    }

    componentDidMount() {
        if (this.props.setRef && typeof this.props.setRef === "function") {
            this.props.setRef(this)
        }

    }

    shouldComponentUpdate() {
        return (
            !this.state.isSubmitting
        )
    }

    componentWillReceiveProps(nextProps) {
        // If component is locked, do apply the changed props
        if (nextProps.locked) {
            return
        }
        let newMappingFields = nextProps.mappingFields
        let unsavedFields = this.state.unsavedFields.map(obj => ({ ...obj }))

        newMappingFields.push(...unsavedFields)

        let eid = newMappingFields && newMappingFields.find(mapField => (mapField.datatype === "e-id"))
        let pid = newMappingFields && newMappingFields.find(mapField => (mapField.datatype === "p-id"))
        let sid = newMappingFields && newMappingFields.find(mapField => (mapField.datatype === "s-id"))

        this.setState({
            mappingFields: newMappingFields,
            hasExternalId: eid !== undefined,
            hasPId: pid !== undefined,
            hasSId: sid !== undefined
        })
    }

    handleChange(e, maxLength) {
        let inputName = e.target.getAttribute("name")
        let openBracketPos = inputName.indexOf('[')
        let closeBracketPos = inputName.indexOf(']')
        let fieldName = inputName.slice(closeBracketPos + 2)
        let index = Number(inputName.slice(openBracketPos + 1, closeBracketPos))
        let fieldValue = e.target.value
        if (e.target.type === "checkbox" || e.target.type === "number") {
            fieldValue = Number(fieldValue)
        }

        let mappingFields = this.state.mappingFields.map(obj => ({ ...obj }))
        let unsavedFields = this.state.unsavedFields.map(obj => ({ ...obj }))
        let oldFieldValue = mappingFields[index][fieldName]
        let datatype = mappingFields[index].datatype
        mappingFields[index][fieldName] = fieldValue

        let hasUnsavedUpdate = false

        let nameRestriction = /^[a-zA-Z0-9-_@$]+$/
        let numericRestriction = /^[0-9]+$/

        if ((fieldName === "field_from") && fieldValue === "") {
            let errors = []
            errors[index] = { "field_from": "This field cannot be empty, use @default instead" }
            this.setState({ errors })
            return
        } else if ((fieldName === "field_from" || fieldName === "field_to") && (fieldValue !== "" && !nameRestriction.test(fieldValue))) {
            let errors = []
            errors[index] = { [fieldName]: "This field cannot contain special characters or spaces" }
            this.setState({ errors })
            return
        } else if (fieldName === "max_length" && fieldValue !== "" && !numericRestriction.test(fieldValue)) {
            let errors = []
            errors[index] = { [fieldName]: "Must be a number" }
            this.setState({ errors })
            return
        }
        // else if ( fieldName==="defaultvalue" && fieldValue==="" && (!mappingFields[index]["field_from"]||!mappingFields[index]["field_to"]) ) {
        //     let errors = []
        //     errors[index] = {"defaultvalue":"Please specify a default value"}
        //     this.setState({errors})
        //     return
        // Allow empty field_to
        // } else if ( fieldName==="field_to" && fieldValue==="" ) {
        //     let errors = []
        //     errors[index] = {"field_to":"This field cannot be empty"}
        //     this.setState({errors})
        //     return
        //}
        else {
            if (fieldName === "field_from" || fieldName === "field_to" || fieldName === "update_flag" || fieldName === "mandatory") {

                /**
                 *  Comment out some validations for duplicate checking for field_to
                 *  Only field_from values should be unique
                 */
                let parentFieldTo = mappingFields[index].related_datadestination


                if (fieldName === "field_from" || fieldName === "field_to") {
                    let parentFieldFrom = mappingFields[index].related_datasource
                    let checkDuplicates = fieldValue ?
                        mappingFields.filter(mapField => (
                            /*(mapField.datatype === "object"||mapField.datatype === "meta"||mapField.datatype === "array") &&*/
                            ((fieldName === "field_from" && mapField.field_from === fieldValue && mapField.related_datasource === parentFieldFrom) && (mapField.datatype === "object" || mapField.datatype === "array" || mapField.datatype === "meta")
                                || (fieldName === "field_to" && mapField.field_to === fieldValue && mapField.related_datadestination === parentFieldTo)
                            )
                        )).length
                        : 0

                    let checkDuplicates2 = fieldValue ?
                        mappingFields.filter(mapField => (
                            /*(mapField.datatype === "object"||mapField.datatype === "meta"||mapField.datatype === "array") &&*/
                            ((fieldName === "field_from" && mapField.field_from === fieldValue && mapField.related_datasource === parentFieldFrom && (mapField.datatype != "object" || mapField.datatype != "array" || mapField.datatype != "meta")) || (fieldName === "field_from" && mapField.field_from === fieldValue && mapField.related_datasource === parentFieldFrom && (mapField.datatype === "object" || mapField.datatype === "array" || mapField.datatype === "meta"))
                                || (fieldName === "field_to" && mapField.field_to === fieldValue && mapField.related_datadestination === parentFieldTo)
                            )
                        ))
                        : ""

                    // let mapDuplicates = checkDuplicates2.length
                    let hasObject = false
                    let hasNonObject = false
                    let hasDuplicate = false
                    let objectNames = []

                    let mapDuplicates = checkDuplicates2 ? checkDuplicates2.map((item, index) => {

                        if (item.datatype === "object" || item.datatype === "meta" || item.datatype === "array") {
                            hasObject = true
                            objectNames.push(item.field_from)
                        } else {
                            hasObject = false
                        }

                        if (objectNames && checkDuplicates2.length > 1) {
                            if (item.field_from === objectNames[0]) {
                                hasDuplicate = true
                            }
                        }
                    }) : ""

                    //console.log("hasDuplicate", hasDuplicate)
                    // console.log("mapping", mappingFields)
                    // console.log("hasObject", hasObject)
                    // console.log("hasNonObject", hasNonObject)
                    // console.log("objectNames", objectNames)



                    if (checkDuplicates > 1 || hasDuplicate) {
                        let errors = []
                        errors[index] = { [fieldName]: "This field is a duplicate" }
                        this.setState({ errors })
                        return
                    }
                }

                if ((datatype && (datatype === "object" || datatype === "meta" || datatype === "array")) || (fieldName === "update_flag" || fieldName === "mandatory")) {
                    // If a child checkbox was unchecked, store the parent/grandparent indexes in this array.
                    // Then iterate through all children to see if all are also unchecked. Only then can the parent
                    // checkbox also be unchecked
                    let parentCheckboxUnchecked = []

                    let relatedDatasource = mappingFields[index].related_datasource
                    let fieldFrom = (fieldName === "field_from") ? oldFieldValue : mappingFields[index].field_from
                    let childUniqueIdentifier = relatedDatasource ? relatedDatasource + "." + fieldFrom : fieldFrom

                    let relatedDataDestination = mappingFields[index].related_datadestination

                    mappingFields.forEach((mapField, index) => {
                        let currentUniqueIdentifier = mapField.related_datasource ? mapField.related_datasource + "." + mapField.field_from : mapField.field_from

                        /**
                         * If the changed field is field_from, we also need to change it's child rows
                         * related_datasource so the child rows are not orphaned
                         */
                        if (fieldName === "field_from" && oldFieldValue) {
                            if (mapField.related_datasource && mapField.related_datasource === childUniqueIdentifier) {
                                mapField.related_datasource = relatedDatasource ? relatedDatasource + "." + fieldValue : fieldValue
                            } else if (mapField.related_datasource && mapField.related_datasource.indexOf(childUniqueIdentifier + ".") === 0) {
                                let newRelatedDatasource = relatedDatasource ? relatedDatasource + "." + fieldValue : fieldValue
                                mapField.related_datasource = mapField.related_datasource.replace(childUniqueIdentifier + ".", newRelatedDatasource + ".")
                            }
                            if (mapField.hasOwnProperty("unsavedId")) {
                                hasUnsavedUpdate = true
                                let updateIndex = unsavedFields.findIndex(field => (field.unsavedId === mapField.unsavedId))
                                unsavedFields[updateIndex].related_datasource = mapField.related_datasource
                            }

                            /**
                             * If the changed field is field_to, we need to change the child rows
                             * data_destination as well so we know the heirarchy
                             */
                        } else if (fieldName === "field_to") {
                            // Detect if this mapping is a child row of the changed row
                            if (mapField.related_datasource &&
                                (
                                    mapField.related_datasource === childUniqueIdentifier ||
                                    mapField.related_datasource.indexOf(childUniqueIdentifier + ".") === 0
                                )
                            ) {
                                if (oldFieldValue) {
                                    if (mapField.related_datadestination === oldFieldValue) {
                                        mapField.related_datadestination = fieldValue
                                    } else if (mapField.related_datadestination && mapField.related_datadestination.includes(oldFieldValue + ".")) {
                                        mapField.related_datadestination = mapField.related_datadestination.replace(oldFieldValue + ".", (fieldValue ? fieldValue + "." : fieldValue))
                                    } else if (mapField.related_datadestination && mapField.related_datadestination.includes("." + oldFieldValue)) {
                                        mapField.related_datadestination = mapField.related_datadestination.replace("." + oldFieldValue, (fieldValue ? "." + fieldValue : fieldValue))
                                    }
                                } else {
                                    let newRelatedDataDesination
                                    if (mapField.related_datadestination) {
                                        if (mapField.related_datasource === childUniqueIdentifier) {
                                            newRelatedDataDesination = relatedDataDestination ? relatedDataDestination + "." + fieldValue : fieldValue
                                        } else {
                                            newRelatedDataDesination = fieldValue + "." + mapField.related_datadestination
                                        }
                                    } else {
                                        newRelatedDataDesination = fieldValue
                                    }
                                    if (newRelatedDataDesination.indexOf("..") > -1) {
                                        newRelatedDataDesination.replace("..", ".")
                                    }
                                    if (newRelatedDataDesination && newRelatedDataDesination[newRelatedDataDesination.length - 1] === ".") {
                                        newRelatedDataDesination = newRelatedDataDesination.slice(newRelatedDataDesination.length - 1)
                                    }
                                    if (newRelatedDataDesination && newRelatedDataDesination[0] === ".") {
                                        newRelatedDataDesination = newRelatedDataDesination.slice(1)
                                    }

                                    mapField.related_datadestination = newRelatedDataDesination

                                    if (mapField.hasOwnProperty("unsavedId")) {
                                        hasUnsavedUpdate = true
                                        let updateIndex = unsavedFields.findIndex(field => (field.unsavedId === mapField.unsavedId))
                                        unsavedFields[updateIndex].related_datadestination = newRelatedDataDesination
                                    }
                                }
                            }


                        } else if ( // if update_flag / mandatory is changed, change all child rows as well
                            (fieldName === "update_flag" || fieldName === "mandatory") &&
                            (mapField.related_datasource === childUniqueIdentifier || // direct child
                                mapField.related_datasource.indexOf(childUniqueIdentifier + ".") === 0 || // grandchild
                                childUniqueIdentifier.indexOf(currentUniqueIdentifier + ".") === 0 //parent or grandparent
                            )) {
                            // If this is a parent row and a child was unchecked
                            if (childUniqueIdentifier.indexOf(currentUniqueIdentifier + ".") === 0 && fieldValue === 0 &&
                                (mapField.datatype && (mapField.datatype === "object" || mapField.datatype === "meta" || mapField.datatype === "array"))) {
                                // Temporarily store parent index instead of directly unchecking, 
                                // since we need to also check all other children before unchecking the parent
                                parentCheckboxUnchecked.push(index)
                            } else {
                                mapField[fieldName] = fieldValue
                            }
                        }
                    })
                    // reverse loop, start from the nearest parent
                    for (let i = parentCheckboxUnchecked.length; i--;) {
                        let hasCheckedChild = false
                        let parentMapField = mappingFields[parentCheckboxUnchecked[i]]
                        let currentParentIdentifier = parentMapField.related_datasource ? parentMapField.related_datasource + "." + parentMapField.field_from : parentMapField.field_from
                        if (i >= 0 && i < parentCheckboxUnchecked.length - 1 && mappingFields[parentCheckboxUnchecked[i + 1]][fieldName]) {
                            hasCheckedChild = true
                            // The previous checked parent is still checked, no need to continue checking
                            break;
                        }
                        mappingFields.forEach((mapField, index) => {
                            if (
                                (mapField.related_datasource === currentParentIdentifier ||
                                    mapField.related_datasource.indexOf(currentParentIdentifier + ".") === 0) &&
                                mapField[fieldName]
                            ) {
                                hasCheckedChild = true
                            }
                        })

                        // current parent has no checked children, it is safe to uncheck it
                        if (!hasCheckedChild) {
                            mappingFields[parentCheckboxUnchecked[i]][fieldName] = 0
                        }
                    }
                }
            }

            // Clear max_length and truncated if datatype was changed 
            // to something other than value or text
            if (fieldName === "datatype" &&
                !(fieldValue === "value" || fieldValue === "text") &&
                (mappingFields[index].max_length || mappingFields[index].is_truncated)
            ) {
                mappingFields[index].max_length = ""
                mappingFields[index].is_truncated = 0
            }

            if (mappingFields[index].hasOwnProperty("unsavedId")) {
                let updateIndex = unsavedFields.findIndex(field => (field.unsavedId === mappingFields[index].unsavedId))
                unsavedFields[updateIndex][fieldName] = fieldValue
                this.setState({ mappingFields, unsavedFields, errors: [] })
            } else {
                if (hasUnsavedUpdate) {
                    this.setState({ mappingFields, unsavedFields, errors: [] })
                } else {
                    this.setState({ mappingFields, errors: [] })
                }
            }
        }
    }

    handleAdd(newRow) {
        let mappingFields = this.state.mappingFields.map(obj => ({ ...obj, newRow: false }))
        let unsavedFields = this.state.unsavedFields.map(obj => ({ ...obj, newRow: false }))
        newRow.unsavedId = unsavedFields.length
        newRow.newRow = true
        //let errors = []
        mappingFields.push(newRow)
        unsavedFields.push(newRow)

        let hasExternalId = newRow.datatype === "e-id" ?
            !this.state.hasExternalId && newRow.datatype === "e-id" : this.state.hasExternalId
        let hasPId = newRow.datatype === "p-id" ?
            !this.state.hasPId && newRow.datatype === "p-id" : this.state.hasPId
        let hasSId = newRow.datatype === "s-id" ?
            !this.state.hasSId && newRow.datatype === "s-id" : this.state.hasSId

        this.setState({ mappingFields, unsavedFields, hasExternalId, hasPId, hasSId }, () => {
            // We need to set newRow = false after the animation so it does not cause an issue where
            // the last parent row added is rerendered and is becomes collapsed instead of expanded
            setTimeout(() => {
                // Use spread (shallow copy) since we are only changing the last row/object
                let mappingFields = [...this.state.mappingFields]
                let unsavedFields = [...this.state.unsavedFields]
                mappingFields[mappingFields.length - 1] = { ...newRow, newRow: false }
                unsavedFields[unsavedFields.length - 1] = { ...newRow, newRow: false }

                this.setState({ mappingFields, unsavedFields })
            }, 500)
        })
    }

    handleDelete(index) {
        let mappingFields = this.state.mappingFields.map(obj => ({ ...obj }))
        let deletedFields = this.state.deletedFields.map(obj => ({ ...obj }))

        // remove the deleted row and push it to deletedFields 
        // This way we have a backup and can restore, and we can delete on submit
        let deletedField = mappingFields.splice(index, 1)[0]

        let hasExternalId = deletedField.datatype === "e-id" ?
            !(this.state.hasExternalId && deletedField.datatype === "e-id") : this.state.hasExternalId
        let hasPId = deletedField.datatype === "p-id" ?
            !(this.state.hasPId && deletedField.datatype === "p-id") : this.state.hasPId
        let hasSId = deletedField.datatype === "s-id" ?
            !(this.state.hasSId && deletedField.datatype === "s-id") : this.state.hasSId

        // Check if the deleted field has an id, if not, don't add it to deletedFields array,
        // since it's not actually in the backend yet (meaning it was added then removed before being saved)
        if (deletedField && deletedField.id && typeof deletedField.id === "number") {
            deletedFields.push(deletedField)
        }

        this.setState({ mappingFields, deletedFields, hasExternalId, hasPId, hasSId })
    }

    handleDeleteAllFields() {
    
        let mapping_id = document.location.pathname.split("/")[2]
        let { accessToken } = this.props

        this.props.dispatch(showMessage({
            type: "info",
            title: "Confirmation",
            message: "Deleting all mapping fields cannot be undone.",
            buttonArray: ["Confirm", "Cancel"],
            showDeleteMe: true,
            autoClose: false,                   
            onClick: async (buttonIndex) => {

                if (buttonIndex === 0) {

                   let result = await deleteAllFields(mapping_id, accessToken)

                    if(!result) {

                        this.props.dispatch(showMessage({
                            type: "error",
                            title: "Error",
                            message: "Unable to delete fields.",
                            buttonArray: ["Close"],
                            autoClose: false,                   
                            onClick: async (buttonIndex) => {
                            }
                        }))
                    } else {

                        this.props.dispatch(showMessage({
                            type: "success",
                            title: "Success",
                            message: "All fields successfully deleted.",
                            buttonArray: ["OK"],
                            autoClose: false,                   
                            onClick: async (buttonIndex) => {

                                window.location.reload()
                            }
                        }))                        
                    }
                } 
            }
        }))

    }

    // Validate form values
    isInvalid() {
        let testObjFrom = {}
        let testObjTo = {}
        let returnVal = false
        let lastErrorIndex = -1
        let nameRestriction = /^[a-zA-Z0-9-_@$]+$/
        let numericRestriction = /^[0-9]+$/

        // Find empty field_from and field_to, find duplicates
        let errors = this.state.mappingFields.map((MappingFieldRow, index) => {
            let errorObj = {}
            //console.log('TEST', [MappingFieldRow, index])
            if (!MappingFieldRow.field_from) {
                returnVal = true
                lastErrorIndex = index
                errorObj["field_from"] = "This field cannot be empty"
            }

            if (MappingFieldRow.field_from && MappingFieldRow.field_from !== "@default" && !nameRestriction.test(MappingFieldRow.field_from)) {
                returnVal = true
                lastErrorIndex = index
                errorObj["field_from"] = "This field cannot contain special characters or spaces"
            }

            // Allow empty field_to
            // if( !MappingFieldRow.field_to ){
            //     returnVal = true
            //     lastErrorIndex = index
            //     errorObj["field_to"] = "This field cannot be empty"
            // } else 
            if (MappingFieldRow.field_to && !nameRestriction.test(MappingFieldRow.field_to)) {
                returnVal = true
                lastErrorIndex = index
                errorObj["field_to"] = "This field cannot contain special characters or spaces"
            }

            if (MappingFieldRow.max_length && !numericRestriction.test(MappingFieldRow.max_length)) {
                returnVal = true
                lastErrorIndex = index
                errorObj["max_length"] = "Must be a number"
            }
            if(MappingFieldRow.is_truncated == 1 && MappingFieldRow.max_length == 0){
                returnVal = true;
                lastErrorIndex = index;
                errorObj["max_length"] = "Required"

            }

            // Allow empty defaultvalue if field_to is empty
            // if( !MappingFieldRow.field_to && !MappingFieldRow.defaultvalue ){
            //     returnVal = true
            //     lastErrorIndex = index
            //     errorObj["defaultvalue"] = "Please specify a default value"
            // }

            if (MappingFieldRow.field_from === "@default" && !MappingFieldRow.defaultvalue) {
                returnVal = true
                lastErrorIndex = index
                errorObj["defaultvalue"] = "Please specify a default value"
            }

            if (MappingFieldRow.field_to === "@default" && !MappingFieldRow.defaultvalue) {
                returnVal = true
                lastErrorIndex = index
                errorObj["defaultvalue"] = "Please specify a default value"
            }

            // else {


            let uniqueIdentifier = MappingFieldRow.related_datasource ?
                MappingFieldRow.related_datasource + "." + MappingFieldRow.field_from :
                MappingFieldRow.field_from

            let uniqueIdentifierFieldTo = MappingFieldRow.related_datadestination ?
                MappingFieldRow.related_datadestination + "." + MappingFieldRow.field_to :
                MappingFieldRow.field_to

            let hasDuplicateInParent = MappingFieldRow.related_datasource &&
                ((MappingFieldRow.related_datasource === MappingFieldRow.field_from) ||
                    MappingFieldRow.related_datasource.includes(MappingFieldRow.field_from + ".") ||
                    MappingFieldRow.related_datasource.includes("." + MappingFieldRow.field_from))

            // Check for uniqueness in field_from and field_to
            // if ((testObjFrom.hasOwnProperty(uniqueIdentifier) || hasDuplicateInParent)) {
            //     returnVal = true
            //     lastErrorIndex = index
            //     errorObj["field_from"] = "This field is a duplicatedd"
            // }
            // else 
            if (MappingFieldRow.field_to && testObjTo.hasOwnProperty(uniqueIdentifierFieldTo)) {
                returnVal = true
                lastErrorIndex = index
                errorObj["field_to"] = "This field is a duplicate"
            }
            else {
                testObjFrom[uniqueIdentifier] = "tested"
                testObjTo[uniqueIdentifierFieldTo] = "tested"
            }
            //}

            return errorObj
        })

        if (returnVal) {
            this.setState({ errors }, () => {

                // We have to do the input focus here, because if we try to do it
                // in the child row component via componenetDidUpdate, performance is bad
                if (this.rowRefs[lastErrorIndex] && typeof this.rowRefs[lastErrorIndex].focusInput === "function") {
                    if (errors[lastErrorIndex].hasOwnProperty("field_from")) {
                        this.rowRefs[lastErrorIndex].focusInput("field_from")
                    } else if (errors[lastErrorIndex].hasOwnProperty("field_to")) {
                        this.rowRefs[lastErrorIndex].focusInput("field_to")
                    }
                }
            })
        }

        return returnVal
    }

    handleSubmit(e) {
        let getEvent = e ? e.target.id : ""
        return new Promise((submitResolve) => {
            // this.props.handleSubmitClick()
            let returnVal = { response: { ok: false } }

            // Assign seq numbers on submit
            let mappingFieldsCopy = this.state.mappingFields.map((mapField, index) => ({
                ...mapField,
                seq_no: this.seqNo[index]
            }))

            this.setState({
                mappingFields: mappingFieldsCopy
            }, () => {
                // initialize a promise array
                let promiseArray = []

                if (!this.isInvalid()) {
                    /**
                     * We need to get the changed rows and only save those so
                     * we do not save unchanged rows, because if we do then it only
                     * adds more processing time
                     */
                    let changedRows = _.differenceWith(mappingFieldsCopy, this.props.mappingFields, _.isEqual)
                    //console.log("ON SAVE", changedRows)

                    if (changedRows.length === 0 && this.state.deletedFields.length === 0) {
                        // If there were no changes, set isSubmitted=true for 200ms even if we are not submitted anything
                        // So there is some kind of feedback
                        this.setState({ isSubmitting: true, errors: [] }, () => {
                            setTimeout(() => {
                                this.setState({ isSubmitting: false }, () => {
                                  
                                    returnVal.response.ok = true
                                    submitResolve(returnVal)
                                    this.setState({ isSubmitting: false })

                                    if(getEvent && getEvent){
                                        this.props.dispatch(

                                            showMessage({
                                                type: "success",
                                                title: "Success",
                                                message: "Field mappings have been successfully saved"
                                            })
                                        )
                                        
                                        this.props.dispatch(ftch(15, true))
                                    }
                                })
                         
                            }, 200)


                            
                           
                        })

                    } else {
                        // Set isSubmitting to true
                        this.setState({ isSubmitting: true, errors: [] }, () => {
                            changedRows.forEach(mappingField => {
                                // Push the returned promise to the promise array
                                promiseArray.push(this.props.dispatch(
                                    editEndpointList(12, "datasourcemappingfields", this.props.accessToken, mappingField)
                                ).then(respObj => {
                                    // Remove the newly saved row from unsavedRows
                                    if (typeof mappingField.unsavedId === "number" && respObj.response.ok) {
                                        let unsavedFields = this.state.unsavedFields.map(obj => ({ ...obj }))
                                        let savedFieldIndex = unsavedFields.findIndex(field => (field.unsavedId === mappingField.unsavedId))
                                        unsavedFields.splice(savedFieldIndex, 1)
                                        this.setState({ unsavedFields })
                                    }

                                    return respObj
                                }))
                            })
                            this.state.deletedFields.forEach(mappingField => {
                                // Push the returned promise to the promise array
                                promiseArray.push(this.props.dispatch(
                                    deleteEndpointList(12, "datasourcemappingfields", mappingField.id, this.props.accessToken)
                                ))
                            })

                            // When all data have been saved/deleted, set isSubmitting to false
                            Promise.all(promiseArray).then(respObj => {
                                // console.log("resbObj",respObj)
                                // console.log("response.json",respObj.response && respObj.json)
                                let errorResponses = respObj.find(obj => !obj.response.ok)
                                if (!errorResponses) {
                                    returnVal.response.ok = true
                                    submitResolve(returnVal)
                                    // this.setState({ isSubmitting: false, deletedFields: [] }, () => {
                                    //     this.props.dispatch(
                                    //         showMessage({
                                    //             type: "success",
                                    //             title: "Success",
                                    //             message: "Field mappings have been successfully saved"
                                    //         })
                                    //     )

                                        
                                    //     this.props.dispatch(ftch(15, true))
                                    // })
                                    this.props.dispatch(
                                        showMessage({
                                            type: "success",
                                            title: "Success",
                                            message: "Field mappings have been successfully saved"
                                        })
                                    )
                                    this.props.dispatch(ftch(15, true))
                                    
                                    this.setState({
                                        isSubmitting: false, deletedFields: []
                                    })
                                    
                                } else {
                                    submitResolve(returnVal)
                                    this.setState({ isSubmitting: false }, () => {
                                        this.setState({ isSubmitting: false })
                                    })
                                }
                            })
                        })
                    }
                } else {
                    submitResolve(returnVal)
                }
            })
        })
    }

    buildRows(parent = null, tierCount = 0, topLevelisArray = false) {

        let rows = this.state.mappingFields.map((mapField, index) => ({ ...mapField, originalIndex: index }))



            // store the original index before sorting
            .sort((elem1, elem2) => {
                let elem1IsArr = elem1.hasOwnProperty("datatype") && (/*elem1.datatype === "object"||*/  elem1.datatype === "array")
                let elem2IsArr = elem2.hasOwnProperty("datatype") && (/*elem2.datatype === "object" ||*/ elem2.datatype === "array")
                let elem1IsEID = elem1.hasOwnProperty("datatype") && ( elem1.datatype === "e-id")
                let elem2IsEID = elem2.hasOwnProperty("datatype") && ( elem2.datatype === "e-id")
                let elem1IsPID = elem1.hasOwnProperty("datatype") && ( elem1.datatype === "p-id")
                let elem2IsPID = elem2.hasOwnProperty("datatype") && ( elem2.datatype === "p-id")

                let elem1Type
                let elem2Type
                // console.log("elem1",elem1)
                // console.log("elem1.datatype",elem1.datatype)
                // console.log("elem2",elem2)
                // console.log("elem2.datatype",elem2.datatype)

                let retVal = 0
                switch(elem1 && elem1.hasOwnProperty("datatype") && elem1.datatype){                
                    case "array":
                        elem1Type = "array"
                        break;
                    case "e-id":
                        elem1Type = "e-id"
                        break;
                    case "p-id":
                        elem1Type = "p-id"
                        break;
                    default:
                        elem1Type = "standard"
                }

                switch(elem2 && elem2.hasOwnProperty("datatype") && elem2.datatype){                
                    case "array":
                        elem2Type = "array"
                        break;
                    case "e-id":
                        elem2Type = "e-id"
                        break;
                    case "p-id":
                        elem2Type = "p-id"
                        break;
                    default:
                        elem2Type = "standard"
                }

                // console.log("elem1Type",elem1Type)
                // console.log("elem2Type",elem2Type)

                if(elem1Type == "standard" && elem2Type == "standard"){
                    retVal = 0
                }else if (elem1Type == "array" && elem2Type == "standard"){
                    retVal = 1
                }else if (elem1Type == "standard" && elem2Type == "array"){
                    retVal = -1
                }else if (elem1Type == "e-id" && elem2Type == "standard"){
                    retVal = -1
                }else if (elem1Type == "standard" && elem2Type == "e-id"){
                    retVal = 1
                }else if (elem1Type == "e-id" && elem2Type == "p-id"){
                    retVal = -1
                }else if (elem1Type == "p-id" && elem2Type == "e-id"){
                    retVal = 1
                }else if (elem1Type == "p-id" && elem2Type == "standard"){
                    retVal = -1
                }else if (elem1Type == "standard" && elem2Type == "p-id"){
                    retVal = 1
                }
                

                // console.log("retVal",retVal)
                // if ((elem1IsArr && elem2IsArr) ||  (!elem1IsArr && !elem2IsArr && !elem1IsEID && !elem2IsEID && !elem1IsPID && !elem2IsPID )) {
                //     console.log("a")
                //     retVal = 0
                // } else if (elem1IsArr && !elem2IsArr) {
                //     console.log("b")
                //     retVal = 1
                // } else if (!elem1IsArr && elem2IsArr) {
                //     console.log("c")
                //     retVal = -1
                // }else if(elem1IsEID && !elem2IsEID) {
                //     console.log("d")
                //     retVal = -1
                // }else if (!elem1IsEID && elem2IsEID) {
                //     console.log("e")
                //     retVal = 1
                // }else if (elem1IsEID && elem2IsPID){
                //     console.log("f")
                //     retVal = 1
                // }else if (elem1IsPID && elem2IsEID){
                //     console.log("g")
                //     retVal = 1
                // }else if (elem1IsPID && !elem2IsPID){
                //     console.log("h")
                //     retVal = -1
                // }else if (!elem1IsPID && elem1IsPID){
                //     console.log("i")
                //     retVal = 1
                // }
                
                return retVal
            }).map(mappingField => {
                let isTopLevel = (mappingField.related_datasource === null || mappingField.related_datasource === "")
                let isChild = typeof parent === "number" && !(mappingField.related_datasource === "" || mappingField.related_datasource === null)
                let parentExists = this.state.mappingFields[parent]

                //let parentStrArray = isChild ? mappingField.related_datadestination.split(".") : []
                //let actualParentFieldName = isChild ? parentStrArray.pop() : ""
                //let grandParent = parentStrArray.length ? parentStrArray.join(".") : ""

                let parentStrArrayFrom = isChild ? mappingField.related_datasource.split(".") : []
                let actualParentFieldNameFrom = isChild ? parentStrArrayFrom.pop() : ""
                let grandParentFrom = parentStrArrayFrom.length ? parentStrArrayFrom.join(".") : ""

                let isChildOfParent = (isChild && parentExists &&
                    (   //actualParentFieldName === this.state.mappingFields[parent].field_to || 
                        actualParentFieldNameFrom === this.state.mappingFields[parent].field_from) &&
                    (   //grandParent ===  this.state.mappingFields[parent].related_datadestination ||
                        grandParentFrom === this.state.mappingFields[parent].related_datasource) &&
                    (this.state.mappingFields[parent].datatype === "object" || this.state.mappingFields[parent].datatype === "meta" || this.state.mappingFields[parent].datatype === "array"))

                if ((parent === null && isTopLevel) || isChildOfParent) {
                    // Set the sequence number during rendering, since this represents the order of the rows
                    this.seqNo[mappingField.originalIndex] = this.rowCounter++

                    let finalTopLevelisArray = (tierCount === 0 && mappingField.datatype === "array") || topLevelisArray
                    let childRows = this.buildRows(mappingField.originalIndex, tierCount + 1, finalTopLevelisArray)
                    let isParent = /*childRows.filter(el=>el!==null).length*/ mappingField.datatype === "object" || mappingField.datatype === "meta" || mappingField.datatype === "array"
                    let allowAdd = isParent || mappingField.datatype === "object" || mappingField.datatype === "meta" || mappingField.datatype === "array"

                    let allowedTypes = {
                        meta: ["F-Id", "Value","Boolean", "Percent", "Text"],
                        object: ["F-Id", "Value","Boolean", "Percent", "Text","Time", "Date", "DateTime"],
                        array: ["F-Id", "Value","Boolean", "Percent", "Text", "Time", "Date", "DateTime", "Object", "Meta"]
                    }

                    if ((tierCount === 1 && finalTopLevelisArray) || (tierCount === 0 && mappingField.datatype === "object")) {
                        allowedTypes.object.push("Object")
                        allowedTypes.object.push("Meta")
                    }

                    let childSpacersFrom = []
                    if (tierCount + 1) {
                        for (let i = 0; i < tierCount + 1; i++) {
                            childSpacersFrom.push(<span key={`child-spacer-${mappingField.originalIndex}-bottom-${i}`} className="row-child-spacer"></span>)
                        }
                    }

                    let returnElement = (
                        <div key={mappingField.originalIndex} className="row"><div className="col no-gutters">
                            <MappingFieldRow
                                key={mappingField.originalIndex}
                                mappingFieldIndex={mappingField.originalIndex}
                                mappingField={mappingField}
                                currentUser={this.props.auth.user.id}
                                createdBy={mappingField.created_by}
                                onChange={this.handleChange}
                                errors={this.state.errors[mappingField.originalIndex]}
                                allowDelete={this.props.isUserAdmin}
                                onDelete={() => {
                                    if (childRows.filter(el => el !== null).length) {
                                        this.props.dispatch(
                                            showMessage({
                                                type: "error",
                                                title: "Action is not allowed",
                                                message: "You cannot delete an object with child rows, please delete all child rows first"
                                            })
                                        )
                                    } else {
                                        this.props.dispatch(
                                            showMessage({
                                                type: "info",
                                                title: "Confirmation",
                                                message: "Deleting this mapping field cannot be undone, are you sure you want to proceed?",
                                                buttonArray: ["Yes", "No"],
                                                autoClose: false,
                                                onClick: (buttonIndex) => {
                                                    if (buttonIndex === 0) {
                                                        if (mappingField.id) {
                                                            this.props.dispatch(
                                                                deleteEndpointList(12, "datasourcemappingfields", mappingField.id, this.props.accessToken)
                                                            ).then(respObj => {
                                                                if (respObj.response.ok) {
                                                                    this.props.dispatch(closeMessage())
                                                                }
                                                            })
                                                        } else {
                                                            let mappingFieldsCopy = this.state.mappingFields.map(obj => ({ ...obj }))
                                                            let unsavedFields = this.state.unsavedFields.map(obj => ({ ...obj }))
                                                            let toDeleteIndex = unsavedFields.findIndex(field => field.unsavedId === mappingField.unsavedId)
                                                            unsavedFields.splice(toDeleteIndex, 1)
                                                            mappingFieldsCopy.splice(mappingField.originalIndex, 1)
                                                            this.setState({
                                                                mappingFields: mappingFieldsCopy,
                                                                unsavedFields
                                                            }, () => {
                                                                this.props.dispatch(closeMessage())
                                                            })
                                                        }

                                                    } else {
                                                        this.props.dispatch(closeMessage())
                                                    }
                                                }
                                            })
                                        )
                                    }
                                }}
                                setRef={instance => this.rowRefs[mappingField.originalIndex] = instance}
                                isChild={isChild}
                                isParent={isParent}
                                tierCount={tierCount}
                                allowAdd={allowAdd}
                                allowedTypes={allowedTypes[mappingField.datatype]}
                                onAddChildRow={(field_from, datatype) => {
                                    let related_datasource = (mappingField.related_datasource) ?
                                        (mappingField.related_datasource + "." + mappingField.field_from) :
                                        mappingField.field_from

                                    let related_datadestination = (mappingField.related_datadestination) ?
                                        (mappingField.related_datadestination + (mappingField.field_to ? "." + mappingField.field_to : "")) :
                                        mappingField.field_to

                                    if (related_datadestination.indexOf("..") > -1) {
                                        related_datadestination.replace("..", ".")
                                    }
                                    if (related_datadestination && related_datadestination[related_datadestination.length - 1] === ".") {
                                        related_datadestination = related_datadestination.slice(related_datadestination.length - 1)
                                    }
                                    if (related_datadestination && related_datadestination[0] === ".") {
                                        related_datadestination = related_datadestination.slice(1)
                                    }

                                    let duplicate = this.state.mappingFields.find(mapField => (
                                        mapField.field_from === field_from && mapField.related_datasource === related_datasource
                                    ))

                                    let nameRestriction = /^[a-zA-Z0-9-_@$]+$/
                                    if (!nameRestriction.test(field_from)) {
                                        return {
                                            success: false,
                                            error: "This field cannot contain special characters or spaces"
                                        }
                                    }

                                    if (duplicate) {
                                        return {
                                            success: false,
                                            error: "This field is a duplicate"
                                        }
                                    } else {
                                        let updateFlag = datatype === "e-id" || datatype === "p-id" ? 1 : 0
                                        this.handleAdd({
                                            "mapping_id": this.props.mappingId,
                                            "field_from": field_from,
                                            "related_datasource": related_datasource,
                                            "field_to": "",
                                            "related_datadestination": related_datadestination,
                                            "datatype": datatype,
                                            "defaultvalue": "",
                                            "max_length": "",
                                            "update_flag": updateFlag,
                                            "mandatory": 0,
                                            "is_truncated": 0,
                                            "transformation": "",
                                            "validation": "",
                                            "remarks": ""
                                        })
                                        return {
                                            success: true,
                                            error: ""
                                        }
                                    }
                                }}
                                topLevelisArray={finalTopLevelisArray}
                            />

                        {/* {this.state.isSubmitting &&
                            <div className="endpoints-list-overlay">
                                <div className="endpoint-list-overlay-icon">
                                    <i className="fas fa-circle-notch fa-spin fa-10x"></i>
                                </div>
                            </div>
                        } */}
                            <div className="row child-row collapse" id={`child-section-${mappingField.originalIndex}`}><div className="col no-gutters">
                                {
                                    childRows
                                }
                                {allowAdd &&
                                    <div className="fieldmapping-row row pt-1">
                                        <div className="col-3 px-1">
                                            <div className="input-group">
                                                {
                                                    childSpacersFrom
                                                }
                                                <span className="row-expand-spacer">
                                                    <i className="fa fa-fw"></i>
                                                </span>
                                                <AddNewForm id={`add-new-bottom-${mappingField.originalIndex}`}
                                                    type="object"
                                                    parentType="object"
                                                    parentKey=""
                                                    onAdd={(field_from, datatype) => {
                                                        let related_datasource = (mappingField.related_datasource) ?
                                                            (mappingField.related_datasource + "." + mappingField.field_from) :
                                                            mappingField.field_from

                                                        let related_datadestination = (mappingField.related_datadestination) ?
                                                            (mappingField.related_datadestination + (mappingField.field_to ? "." + mappingField.field_to : "")) :
                                                            mappingField.field_to

                                                        if (related_datadestination.indexOf("..") > -1) {
                                                            related_datadestination.replace("..", ".")
                                                        }
                                                        if (related_datadestination && related_datadestination[related_datadestination.length - 1] === ".") {
                                                            related_datadestination = related_datadestination.slice(related_datadestination.length - 1)
                                                        }
                                                        if (related_datadestination && related_datadestination[0] === ".") {
                                                            related_datadestination = related_datadestination.slice(1)
                                                        }

                                                        let duplicate = this.state.mappingFields.find(mapField => (
                                                            mapField.field_from === field_from && mapField.related_datasource === related_datasource
                                                        ))

                                                        let nameRestriction = /^[a-zA-Z0-9-_@$]+$/
                                                        if (!nameRestriction.test(field_from)) {
                                                            return {
                                                                success: false,
                                                                error: "This field cannot contain special characters or spaces"
                                                            }
                                                        }

                                                        if (duplicate) {
                                                            return {
                                                                success: false,
                                                                error: "This field is a duplicate"
                                                            }
                                                        } else {
                                                            let updateFlag = datatype === "e-id" || datatype === "p-id" ? 1 : 0
                                                            this.handleAdd({
                                                                "mapping_id": this.props.mappingId,
                                                                "field_from": field_from,
                                                                "related_datasource": related_datasource,
                                                                "field_to": "",
                                                                "related_datadestination": related_datadestination,
                                                                "datatype": datatype,
                                                                "defaultvalue": "",
                                                                "max_length": "",
                                                                "update_flag": updateFlag,
                                                                "mandatory": 0,
                                                                "is_truncated": 0,
                                                                "allow_null":0,
                                                                "transformation": "",
                                                                "validation": "",
                                                                "remarks": ""
                                                            })
                                                            return {
                                                                success: true,
                                                                error: ""
                                                            }
                                                        }
                                                    }}
                                                    allowedTypes={allowedTypes[mappingField.datatype]}
                                                    //allowedTypes={console.log(allowedTypes[mappingField.datatype])}
                                                    buttonText={`Add Field`}
                                                    placeholder={`Source Fields`}
                                                    dropdownProps={{
                                                        "data-flip": false
                                                    }}
                                                    menuClasses={["dropright", "fit-row"]}
                                                    buttonClasses={["fit-row"]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div></div>
                        </div></div>
                    )

                    if (mappingField.newRow) {
                        return (
                            <CSSTransition
                                key={`transition-${mappingField.originalIndex}`}
                                in={true}
                                appear={true}
                                timeout={500}
                                classNames="fade"
                            >
                                {returnElement}
                            </CSSTransition>
                        )
                    } else {
                        return returnElement
                    }
                } else {
                    return null
                }
            })

        return rows
    }

    render() {
        let {
            mappingId,
            isFetching,
            datasource,
            datatarget,
            // isUserAdmin
        } = this.props

        let {
            mappingFields,
            isSubmitting,
            errors,
            hasExternalId,
            hasPId,
            // hasSId
        } = this.state

        // console.log(this.state.mappingFields)


        // Reset row counter to 1
        this.rowCounter = 1

        let allowedTypes = ["S-Id", "Value","Boolean", "Percent", "Text", "List", "Date", "Time", "DateTime", "Object", "Array", "Meta"]

        // if( !hasSId ){
        //     allowedTypes.unshift("S-Id")
        // }
        if (!hasPId) {
            allowedTypes.unshift("P-Id")
        }
        if (!hasExternalId) {
            allowedTypes.unshift("E-Id")
        }

        return (
            <div className="fieldmapping pb-5">
                 {isSubmitting &&
                        <div className="integration-form-overlay">
                            <div className="integration-form-overlay-icon">
                            <i className="fa fa-circle-notch integration fa-spin fa-lg"></i>
                            </div>
                        </div>
                    }
                <div className="row fieldmap-table-header">
                    <div className="col-12 field-mapping-header-label-wrapper">
                        <div className="row fieldmap-table-toolbar py-1 clearfix">
                            <div className="col ml-1">
                                <AddNewForm id="add-new-main-fieldmapping"
                                    type="object"
                                    parentType="object"
                                    parentKey=""
                                    onAdd={(field_from, datatype) => {
                                        let duplicate = this.state.mappingFields.find(mapField => (
                                            mapField.field_from === field_from &&
                                            (mapField.related_datasource === "" || mapField.related_datasource === null) && (mapField.datatype === "object" || mapField.datatype === "array" || mapField.datatype === "meta")
                                        ))

                                        let nameDuplicate = this.state.mappingFields.find(mapField => (
                                            mapField.field_from === field_from &&
                                            (mapField.related_datasource === "" || mapField.related_datasource === null) && (datatype === "object" || datatype === "array" || datatype === "meta")
                                        ))

                                        let nameRestriction = /^[a-zA-Z0-9-_@$]+$/
                                        if (!nameRestriction.test(field_from)) {
                                            return {
                                                success: false,
                                                error: "This field cannot contain special characters or spaces"
                                            }
                                        }

                                        if (duplicate || nameDuplicate) {
                                            return {
                                                success: false,
                                                error: "This field is a duplicate"
                                            }
                                        } else {
                                            let updateFlag = datatype === "e-id" || datatype === "p-id" ? 1 : 0
                                            this.handleAdd({
                                                "mapping_id": mappingId,
                                                "field_from": field_from,
                                                "related_datasource": "",
                                                "field_to": "",
                                                "related_datadestination": "",
                                                "datatype": datatype,
                                                "defaultvalue": "",
                                                "max_length": "",
                                                "update_flag": updateFlag,
                                                "mandatory": 0,
                                                "is_truncated": 0,
                                                "transformation": "",
                                                "validation": "",
                                                "remarks": ""
                                            })
                                            return {
                                                success: true
                                            }
                                        }
                                    }}
                                    allowedTypes={allowedTypes}
                                    buttonText="Add New Field"
                                    placeholder={`Source Field`} />
                                <button className="btn btn-sm" type="button" disabled={isSubmitting || isFetching } id="mappingField-btn"
                                    onClick={this.handleSubmit}>
                                    {isSubmitting ?

                                        <i className="fa fa-circle-notch fa-spin fa-fw"></i> :
                                        (errors.length ? <i className="fa fa-exclamation-triangle fa-fw"></i> : <i className="fa fa-save fa-fw"></i>)
                                    } Apply
                                </button>
                                <button className="btn btn-sm btn-red float-right" type="button" id="mappingFieldDeleteAllField-btn" disabled={!this.state.mappingFields.length}
                                    onClick={this.handleDeleteAllFields} ><i className="fa fa-trash"></i> Delete All Fields 
                                </button>
                            </div>
                            <div className="float-right">

                            </div>
                        </div>
                    </div>
                </div>
                <div className="sticky-element">
                    <div className="row col-12 field-mapping-header-label align-items-center">
                        <div className="col-3 px-1 text-center"><h6>From: <b>{datasource && datasource.description}</b> </h6></div>
                        <div className="col-3 px-1 text-center"><h6>To:  <b>{datatarget && datatarget.description}</b> </h6></div>
                        <div className="col-1-2 px-1 text-center"><h6>Default Value</h6></div>
                        <div className="col-1-2 px-1 text-center"><h6>Data Type</h6></div>
                        <div className="col-1-2 px-1 text-center"><h6>Max Length</h6></div>
                        <div className="col-1-2  no-gutters text-center"><h6>Truncated</h6></div>
                        <div className="col-1-2 pr-4 no-gutters text-center"><h6>Update</h6></div>
                        <div className="col-1-2 pr-5 no-gutters text-center"><h6>Mandatory</h6></div>
                        <div className="col-1-2 pr-4 no-gutters text-center"><h6>Allow Null</h6></div>
                        <div className="col-1-2 no-gutters"></div>
                    </div>
                </div>
                <div className="pb-3 pt-2 fieldmapping-body">
                    {mappingFields ? this.buildRows() : null
                    }
                    {(isFetching && !isSubmitting && mappingFields.length === 0) && (
                        <div className="row pt-2 ">
                            <div className="col px-3 text-center">
                                <i className="fa fa-circle-notch fa-spin fa-lg"></i>
                            </div>
                        </div>
                    ) 
                    }
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    let dsMappingEndpoint = state.endpoints.find(endpoint => endpoint.name === 'datasourcemappings')
    let dsMappingFieldsEndpoint = state.endpoints.find(endpoint => endpoint.name === 'datasourcemappingfields')
    let datasourceEndpoint = state.endpoints.find(endpoint => endpoint.name === 'datasources')

    let mappingFieldsIsFetching = dsMappingFieldsEndpoint.isFetching
    let mapping = dsMappingEndpoint && dsMappingEndpoint.list.find(dsMap => dsMap.id === ownProps.mappingId)
    let mappingFields = dsMappingFieldsEndpoint.list.filter(mapField => (mapField.mapping_id === ownProps.mappingId))
    //console.log('datasourcemappingfields',mappingFields)
    let datasource = mapping ? datasourceEndpoint.list.find(datasource => datasource.id === mapping.datasource_id) : null
    let datatarget = mapping ? datasourceEndpoint.list.find(datasource => datasource.id === mapping.datatarget_id) : null

    let isUserAdmin = state.auth.user.isAdmin
    let auth = state.auth

    mappingFields.sort((elem1, elem2) => {
        let retVal = 0
        if (elem1.seq_no > elem2.seq_no) {
            retVal = 1
        } else if (elem2.seq_no > elem1.seq_no) {
            retVal = -1
        } else {
            retVal = 0
        }

        return retVal
    })

    return {
        mappingId: ownProps.mappingId,
        datasource,
        datatarget,
        isFetching: mappingFieldsIsFetching,
        mappingFields: mappingFields,
        accessToken: state.auth.access_token,
        auth,

        /**
         * @TODO :Check for the possibility to use this prop to validate if 
         *        non-admin user can only delete the FieldMappingRow they've created.
         * @validation :non-admin & current user  === MappingFieldRow userID 
         *             (Coordinate with backend TEAM to add a property "userID"
         *             to mappingfields table in Loopback)
         * 
         * @reference : LOOKUP "handleAdd", "AddNewForm", ""
         */

        isUserAdmin: isUserAdmin

        /** End of TODO */
    }
}

export default connect(mapStateToProps)(MappingFieldTable)


// WEBPACK FOOTER //
// ./src/components/MappingFieldTable.js